import { connect, MapStateToProps } from 'react-redux';
import {
  getCurrentUserHasCore,
  getPublicSession,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../types/store';
import {
  getCurrentCoreSubscriptionV3,
  getGiftUser,
  getPackageBenefits,
  getPackageConfig,
  getSale,
} from '../../../../redux/packagePicker/selectors';
import { Props } from './Hero';
import { getReferer } from '../../../../selectors/common';

export type StateProps = Pick<
  Props,
  | 'userJoinDate'
  | 'giftUser'
  | 'referer'
  | 'hasCore'
  | 'currentCoreSubscription'
  | 'packageBenefits'
  | 'packageConfig'
  | 'sale'
>;

export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  userJoinDate: getPublicSession(state).joinDate,
  giftUser: getGiftUser(state),
  referer: getReferer(state) || '',
  hasCore: getCurrentUserHasCore(state),
  currentCoreSubscription: getCurrentCoreSubscriptionV3(state),
  packageBenefits: getPackageBenefits(state),
  packageConfig: getPackageConfig(state),
  sale: getSale(state),
});

export default connect(mapStateToProps);
